import React from "react";
import { WEB_ROUTES } from "./constants.js";
import FoundingMemberManagementScreen from "./Pages/FoundingMemberManagement/FoundingMemberManagementScreen.js";

const Account = React.lazy(() => import("./Pages/Account/index.js"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/index.js"));
const AdvertisementManagementScreen = React.lazy(() =>
  import("./Pages/AdvertisementManagement/AdvertisementManagementScreen.js")
);
const ShowAdsScreen = React.lazy(() =>
  import("./Pages/AdvertisementManagement/ShowAdsScreen.js")
);
const AlbumContentScreen = React.lazy(() =>
  import("./Pages/AlbumsManagement/AlbumContentScreen.js")
);
const AlbumsManagementScreen = React.lazy(() =>
  import("./Pages/AlbumsManagement/AlbumsManagementScreen.js")
);
const CategoryManagementScreen = React.lazy(() =>
  import("./Pages/CategoryManagement/CategoryManagementScreen.js")
);
const ProductsScreen = React.lazy(() =>
  import("./Pages/CategoryManagement/ProductScreen.js")
);
const ContentDetails = React.lazy(() =>
  import("./Pages/ContentManagement/ContentDetails.js")
);
const ContentManagementScreen = React.lazy(() =>
  import("./Pages/ContentManagement/ContentManagementScreen.js")
);
const ReportDetails = React.lazy(() =>
  import("./Pages/ReportManagement/ReportDetails.js")
);
const ReportManagementScreen = React.lazy(() =>
  import("./Pages/ReportManagement/ReportManagementScreen.js")
);
const EarlyAccessIncentiveManagementScreen = React.lazy(() =>
  import(
    "./Pages/EarlyAccessIncentiveManagement/EarlyAccessIncentiveManagementScreen.js"
  )
);
const ShowCSVDataScreen = React.lazy(() =>
  import("./Pages/EarlyAccessIncentiveManagement/ShowCSVDataScreen.js")
);
const PageManagementScreen = React.lazy(() =>
  import("./Pages/PageManagement/PageManagementScreen.js")
);
const ReferralsManagementScreen = React.lazy(() =>
  import("./Pages/ReferralsManagement/ReferralsManagementScreen.js")
);
const ForeverFreeReferralManagementScreen = React.lazy(() =>
  import(
    "./Pages/ForeverFreeReferralManagement/ForeverFreeReferralManagementScreen.js"
  )
);
const SendNotificationScreen = React.lazy(() =>
  import("./Pages/SendNotification/SendNotificationScreen.js")
);
const Setting = React.lazy(() => import("./Pages/Setting/index.js"));
const UserDetails = React.lazy(() =>
  import("./Pages/UserManagement/UserDetails.js")
);
const UserManagementScreen = React.lazy(() =>
  import("./Pages/UserManagement/UserManagementScreen.js")
);

export const routeConfig = [
  {
    path: WEB_ROUTES.ACCOUNT,
    component: Account,
    isPublic: true,
    exact: true,
  },
  {
    path: WEB_ROUTES.DASHBOARD,
    component: Dashboard,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.USER_MANAGEMENT,
    component: UserManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.USER_DETAILS,
    component: UserDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.CATEGORY_MANAGEMENT,
    component: CategoryManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PRODUCTS_MANAGEMENT,
    component: ProductsScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.REFERRALS_MANAGEMENT,
    component: ReferralsManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.FOREVER_FREE_REFERRALS,
    component: ForeverFreeReferralManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.ALBUMS_MANAGEMENT,
    component: AlbumsManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.ALBUMS_CONTENT_MANAGEMENT,
    component: AlbumContentScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.CONTENTS_MANAGEMENT,
    component: ContentManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.CONTENTS_DETAILS_MANAGEMENT,
    component: ContentDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.REPORTS_MANAGEMENT,
    component: ReportManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.REPORTS_DETAILS_MANAGEMENT,
    component: ReportDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.FOUNDING_MEMBER_MANAGEMENT,
    component: FoundingMemberManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    // exact: true,
  },
  {
    path: WEB_ROUTES.EARLY_ACCESS_MANAGEMENT,
    component: EarlyAccessIncentiveManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SHOW_DATA,
    component: ShowCSVDataScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.ADVERTISEMENT_MANAGEMENT,
    component: AdvertisementManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SHOW_ADS,
    component: ShowAdsScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PAGE_MANAGEMENT,
    component: PageManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SEND_NOTIFICATION,
    component: SendNotificationScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SETTING,
    component: Setting,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
];
